import moment from 'moment'
import { ILease } from '@api'
import { SERVER_DATETIME_FMT } from '@constants'
import assets from './assets'
import details from './details'
import list, { csv } from './list'
import remove from './remove'
import save from './save'
import search from './search'
import event from './event'
import notifications, { updateNotification } from './notifications'
import template from './template'

export default {
  assets,
  csv,
  details,
  event,
  list,
  notifications,
  updateNotification,
  remove,
  save,
  search,
  template,
}

export function parseContract(contract: any): ILease {
  if (typeof contract.metadata !== 'string') return contract
  contract.metadata = JSON.parse(contract.metadata)
  for (const d of ['endDate', 'startDate', 'noticeDate', 'reminderDate', 'effectiveDate']) {
    if (!contract[d]) continue
    contract[d] = moment(contract[d], SERVER_DATETIME_FMT).toDate()
  }
  return contract
}
